export default "__VITE_ASSET__a6eafd29__"